import { CustomersResponse, UserResponse,Staff } from 'types/users/userTypes';
import { apiClient } from '../client';

export const fetchFoodcourtStaff = async():Promise<UserResponse> =>{
   const response= await apiClient.get<UserResponse>(`/usermanagement/admin/foodcourts`,{
    headers:{
        Authorization:`Bearer  ${localStorage.getItem('token')}`
    }
   });
   return response.data;    
}

export const fetchCustomers = async():Promise<CustomersResponse> =>{
    const response= await apiClient.get<CustomersResponse>(`/customer/admin/customers`,{
     headers:{
         Authorization:`Bearer  ${localStorage.getItem('token')}`
     }
    });
    return response.data;    
 }

 export const fetchStaff = async():Promise<Staff[]> =>{
    const response= await apiClient.get<any>(`/usermanagement/admin/staff`,{
     headers:{
         Authorization:`Bearer  ${localStorage.getItem('token')}`
     }
    });
    // API returns paginated response { content: [...], totalPages, ... }
    return response.data?.content || response.data || [];
 }

 export const postStaff = async(data:any):Promise<string> =>{
    const response= await apiClient.post<string>(`/usermanagement/admin/staff/create`,data,{
     headers:{
         Authorization:`Bearer  ${localStorage.getItem('token')}`
     }
    });
    return response.data;    
 }